import { forwardRef, useState } from "react";
import { Alert, Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, LinearProgress, Slide, TextField, Typography } from "@mui/material";
import { newEmployee } from "./employee_halper";
import { validPhoneNumber } from "../client/client_halper";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const designation = ["Delivery Boy", "Receptionist", "Senior Executive", "Office Boy", "Assistant Operations", "Executive Operations"];

function NewEmployee({ onClose, open }) {
    const [inputErrors, setInputErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);

    const handleSelfClose = () => {
        if (isLoading) return;
        setInputErrors({});
        setAlertMessage(null);
        onClose();
    }

    const __error_handler = (test, vr, msg) => {
        if (test) {
            inputErrors[vr] = "";
            setInputErrors({ ...inputErrors });
        } else {
            inputErrors[vr] = msg;
            setInputErrors({ ...inputErrors });
        }
        return !test;
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (isLoading) return;
        const data = new FormData(event.currentTarget);
        const name = data.get("name");
        const username = data.get("username");
        const phone = data.get("phone");
        const designation = data.get("designation");
        var flag = true;

        if (__error_handler(name.length > 3, "name", "Please enter valid name.")) {
            flag = false;
        }
        if (__error_handler(username.length > 3, "username", "Incorrect username.")) {
            flag = false;
        }
        if (__error_handler(validPhoneNumber(phone, true), "phone", "Incorrect phone number.")) {
            flag = false;
        }
        if (__error_handler(designation.length > 3, "designation", "Incorrect enter valid designation.")) {
            flag = false;
        }
        if (flag) {
            const _json = { "name": name, "username": username, "phone": phone, "designation": designation };
            setIsLoading(true);
            newEmployee(_json).then((_) => {
                setAlertMessage({ "severity": "success", "message": "New employee added created." })
                setIsLoading(false);
                handleSelfClose();
            }).catch((err) => {
                setAlertMessage({ "severity": "error", "message": err.message })
                setIsLoading(false);
            });
        }
    }

    const validateInputs = () => {
        return true;
    }

    return (
        <Dialog open={open} onClose={handleSelfClose} TransitionComponent={Transition} >
            <Box component="form" onSubmit={handleSubmit} noValidate>
                <DialogTitle variant="h5" color="info">Employee Create</DialogTitle>
                <DialogContent>
                    {alertMessage === null ? "" :
                        <Box sx={{ mt: 2, mb: 2 }}>
                            <Alert severity={alertMessage.severity}>{alertMessage.message}</Alert>
                        </Box>
                    }
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField variant="outlined" name="name" fullWidth error={inputErrors.name} type="text" helperText={inputErrors.name} placeholder="Employee Name" label="Name (as per aadhar)" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField variant="outlined" name="username" fullWidth error={inputErrors.username} type="text" helperText={inputErrors.username} placeholder="Username use for login" label="Username" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField variant="outlined" name="phone" fullWidth error={inputErrors.phone} type="number" helperText={inputErrors.phone} placeholder="Phone" label="Phone" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <Autocomplete
                                freeSolo
                                disablePortal
                                options={designation}
                                renderInput={(params) => <TextField {...params} variant="outlined" name="designation" fullWidth error={inputErrors.designation} type="text" helperText={inputErrors.designation} autoFocus placeholder="Designation" label="Designation" />}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }}>
                            <Typography variant="caption" color="warning">Default password is <b>crm123</b>.</Typography>
                        </Grid>
                    </Grid>
                </DialogContent>
                {isLoading ? <LinearProgress color="secondary" /> : ""}
                <DialogActions>
                    <Button type="submit" variant="contained" fullWidth onClick={validateInputs} color="success">Save</Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
}

export default NewEmployee;
